import { EmojiClickData } from "emoji-picker-react";
import { useEffect, useState } from "react";

const useEmojiPicker = (
  initialIcon: string,
  onIconChange: (icon: string) => void
) => {
  const [icon, setIcon] = useState("");

  useEffect(() => {
    setIcon(initialIcon ? initialIcon : "");
  }, [initialIcon]);

  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const handleEmojiSelect = (emojiObject: EmojiClickData) => {
    setIcon(emojiObject.emoji);
    onIconChange(emojiObject.emoji);
    setShowEmojiPicker(false);
  };

  return {
    icon,
    showEmojiPicker,
    setShowEmojiPicker,
    handleEmojiSelect,
  };
};

export default useEmojiPicker;
